import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoginPage from '../../pages/LoginPage';
import RegisterPage from '../../pages/RegisterPage';

/**
 * ETAPA 11 — PAINEL DE ENTRAR/CADASTRO DA LANDING
 *
 * A página pública virou a página inicial, e o lugar do card de campeonato no
 * hero passou a ser o acesso. Em vez de reescrever um formulário de login (o que
 * criaria DUAS versões para manter em sincronia), este painel EMBUTE as telas
 * que já existem, com a prop `embutido` — que só remove a moldura de página.
 *
 * Toda a lógica é a mesma das telas dedicadas: estado, chamadas de API, login
 * com Google, mensagens de erro e redirecionamento pós-login.
 *
 * QUAL DOS DOIS APARECE vem do hash da URL:
 *     #entrar       -> login      (o padrão)
 *     #criar-conta  -> cadastro
 *
 * Assim TODO link do sistema que antes levava para /login ou /register agora
 * aponta para cá e já abre no modo certo — inclusive os que estão em outras
 * páginas (para onde o hash viaja junto).
 */
export function PainelEntrar() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const caixaRef = useRef(null);

  const ehCadastro = hash === '#criar-conta';
  const pediuFoco = hash === '#entrar' || hash === '#criar-conta';

  /* Quem chega de outra página clicando em "Entrar" precisa VER o formulário:
     sem isto o painel fica abaixo da dobra e o clique parece não ter feito nada. */
  useEffect(() => {
    if (pediuFoco && caixaRef.current?.scrollIntoView) {
      caixaRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [pediuFoco, hash]);

  return (
    <div id="entrar" ref={caixaRef} data-testid="painel-entrar">
      {ehCadastro ? (
        <RegisterPage embutido aoIrParaLogin={() => navigate({ hash: '#entrar' })} />
      ) : (
        <LoginPage embutido aoIrParaCadastro={() => navigate({ hash: '#criar-conta' })} />
      )}
    </div>
  );
}

export default PainelEntrar;
